/**
 * Detect user's country from browser timezone and language.
 * No external API calls, no permissions needed.
 * Returns ISO 3166-1 alpha-2 country code (e.g., "GB", "US") or null.
 */

const TIMEZONE_COUNTRY_MAP = {
  // United Kingdom & Ireland
  'Europe/London': 'GB',
  'Europe/Dublin': 'IE',
  'Europe/Belfast': 'GB',

  // Western Europe
  'Europe/Berlin': 'DE',
  'Europe/Paris': 'FR',
  'Europe/Madrid': 'ES',
  'Europe/Rome': 'IT',
  'Europe/Amsterdam': 'NL',
  'Europe/Brussels': 'BE',
  'Europe/Zurich': 'CH',
  'Europe/Vienna': 'AT',
  'Europe/Lisbon': 'PT',
  'Europe/Luxembourg': 'LU',

  // Northern Europe
  'Europe/Stockholm': 'SE',
  'Europe/Copenhagen': 'DK',
  'Europe/Oslo': 'NO',
  'Europe/Helsinki': 'FI',

  // Eastern Europe
  'Europe/Warsaw': 'PL',
  'Europe/Prague': 'CZ',
  'Europe/Budapest': 'HU',
  'Europe/Bucharest': 'RO',
  'Europe/Athens': 'GR',

  // United States
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'America/Phoenix': 'US',
  'America/Anchorage': 'US',
  'Pacific/Honolulu': 'US',
  'America/Indiana/Indianapolis': 'US',
  'America/Detroit': 'US',
  'America/Boise': 'US',

  // Canada
  'America/Toronto': 'CA',
  'America/Vancouver': 'CA',
  'America/Edmonton': 'CA',
  'America/Winnipeg': 'CA',
  'America/Halifax': 'CA',
  'America/St_Johns': 'CA',

  // Mexico
  'America/Mexico_City': 'MX',
  'America/Tijuana': 'MX',

  // Australia & New Zealand
  'Australia/Sydney': 'AU',
  'Australia/Melbourne': 'AU',
  'Australia/Brisbane': 'AU',
  'Australia/Perth': 'AU',
  'Australia/Adelaide': 'AU',
  'Pacific/Auckland': 'NZ',

  // Asia-Pacific
  'Asia/Tokyo': 'JP',
  'Asia/Singapore': 'SG',
  'Asia/Kolkata': 'IN',
  'Asia/Shanghai': 'CN',
  'Asia/Hong_Kong': 'HK',
  'Asia/Seoul': 'KR',

  // South America
  'America/Sao_Paulo': 'BR',
  'America/Argentina/Buenos_Aires': 'AR',

  // Middle East
  'Asia/Dubai': 'AE',
  'Asia/Jerusalem': 'IL',

  // Africa
  'Africa/Johannesburg': 'ZA',
  'Africa/Lagos': 'NG',
  'Africa/Cairo': 'EG',
};

export function detectUserCountry() {
  try {
    // 1. Try timezone (most reliable — not spoofable by language settings)
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TIMEZONE_COUNTRY_MAP[tz]) {
      return TIMEZONE_COUNTRY_MAP[tz];
    }

    // 2. Try navigator.language region (e.g., "en-GB" → "GB", "fr-FR" → "FR")
    const lang = navigator.language || '';
    const parts = lang.split('-');
    if (parts.length >= 2 && parts[1].length === 2) {
      return parts[1].toUpperCase();
    }

    // 3. Can't determine
    return null;
  } catch {
    return null;
  }
}
